export const MODULES = {
  dashboard: "dashboard",
  analytics: "analytics",
  inbox: "inbox",
  client: "client",
  account: "account",
  kyc: "kyc",
  wallet: "wallet",
  commission: "commission",
  ib_manager: "ib_manager",
  sales: "sales",
  report: "report",
  banner: "banner",
  subadmin: "subadmin",
  support: "support",
  tutorial: "tutorial",
  email_template: "email_template",
  email_marketing: "email_marketing",
  account_type: "account_type",
  setting: "setting",
  log: "log",
  cash_deposit: "cash_deposit",
  // Sub-modules
  withdraw: "withdraw",
  deposit: "deposit",
  credit: "credit",
  internal_transfer: "internal_transfer",
  comm_generate: "comm_generate",
  comm_withdraw: "comm_withdraw",
  comm_report: "comm_report",
  plan: "plan",
  leads: "leads",
  source: "source",
  volume_report: "volume_report",
  office_goals: "office_goals",
  team_goals: "team_goals",
  ftd_report: "ftd_report",
  ticket: "ticket",
  faq: "faq",
  notification: "notification",
  rule: "rule",
  tnc: "tnc",
  psp: "psp",
  threshold: "threshold",
  symbol: "symbol",
  bank_detail: "bank_detail",
  deposit_request: "deposit_request",
  usd_conversion: "usd_conversion",
  sales_office: "sales_office",
};

export const ACTIONS = {
  view: "view",
  create: "create",
  update: "update",
  delete: "delete",
  export: "export",
  import: "import",
  accept_reject: "accept_reject",
  login: "login",
  change_password: "change_password",
  update_permission: "update_permission",
  ticket_action: "ticket_action",
  ticket_assign: "ticket_assign",
  view_password: "view_password",
  send_ib_request: "send_ib_request",
  ib_details: "ib_details",
  parent_tree: "parent_tree",
  ib_tree: "ib_tree",
  change_mt5_password: "change_mt5_password",
  send_crm_credentials: "send_crm_credentials",
  send_notification: "send_notification",
  client_kyc: "client_kyc",
  client_accounts: "client_accounts",
  client_deposit: "client_deposit",
  client_withdraw: "client_withdraw",
  client_log: "client_log",
  sync: "sync",
};

export const CLIENT_URL = process.env.REACT_APP_CLIENT_URL;

export const getReferralRegistrationLink = (referralCode) =>
  referralCode ? `${CLIENT_URL}/?tab=register&ref=${referralCode}` : "";
